const NEXTIVA_CX_PRODUCT = 'SocialCloud';
const NEXTIVA_CX_SOCIAL_STANDARD_FEATURE = 'CXSocialStandard';
const NEXTIVA_CX_SOCIAL_GROWTH_FEATURE = 'CXSocialGrowth';
const NEXTIVA_CX_FREE_TRIAL_FEATURE = 'PRODUCT_LED_FREE_TRIAL';
const NEXTIVA_CX_TRIAL_STATE = 'STATE';
const NEXTIVA_CX_ENABLED_ACCOUNT = 'ENABLED';
const NEXTIVA_CX_ACTIVATED_ACCOUNT = 'ACTIVATED';
const NEXTIVA_CX_CONVERTED_ACCOUNT = 'CONVERTED';

export const CX_TRIAL_USER = 'NEXTIVA_CX_FREE_TRIAL_USER';
export const CX_PAID_USER = 'NEXTIVA_CX_PAID_USER';
export const CX_UNLICENSED_USER = 'NEXTIVA_CX_UNLICENSED_USER';

export const getNextivaCXLicensingStatus = (licenses): string => {
  let nextivaCXStatus = CX_UNLICENSED_USER;

  licenses?.some((license) => {
    if (license?.product !== NEXTIVA_CX_PRODUCT) return false;

    const licenseFeatures = license?.features || [];
    const isPaidUserWithoutTrial =
      (licenseFeatures.includes(NEXTIVA_CX_SOCIAL_STANDARD_FEATURE) ||
        licenseFeatures.includes(NEXTIVA_CX_SOCIAL_GROWTH_FEATURE)) &&
      !licenseFeatures.includes(NEXTIVA_CX_FREE_TRIAL_FEATURE);

    if (isPaidUserWithoutTrial) {
      nextivaCXStatus = CX_PAID_USER;
      return true;
    }

    const featureAttributes = license?.featuresAttributes;
    featureAttributes?.some((featureAttribute) => {
      if (featureAttribute?.name !== NEXTIVA_CX_FREE_TRIAL_FEATURE)
        return false;

      const attributes = featureAttribute?.attributes;
      attributes?.some((attribute) => {
        if (attribute?.name !== NEXTIVA_CX_TRIAL_STATE) return false;

        const attributeValue = attribute?.value;
        if (
          attributeValue === NEXTIVA_CX_ENABLED_ACCOUNT ||
          attributeValue === NEXTIVA_CX_ACTIVATED_ACCOUNT
        )
          nextivaCXStatus = CX_TRIAL_USER;
        else if (attributeValue === NEXTIVA_CX_CONVERTED_ACCOUNT)
          nextivaCXStatus = CX_PAID_USER;

        return true;
      });
      return true;
    });
    return true;
  });

  return nextivaCXStatus;
};
